import Testimonial from "../../../models/Testimonial"
import './TestimonialCard.css'

interface TestimonialProps {
    testimonial: Testimonial
}

function TestimonialDisplay({testimonial}: TestimonialProps) {
 
 
    return (
    <div className="testimonial-card">
            <p className="testimonial-message">"{testimonial.statement}"</p>
            <p className="testimonial-author">-{testimonial.author}</p>
    </div>
 )
}

export default TestimonialDisplay